export const COUNTRY_DEFAULT_LANGUAGE = {

  AD: 'Spanish',
  AE: 'Arabic',
  AF: 'Arabic',
  AG: 'English',
  AI: 'English',
  AL: 'Albanian',
  AM: 'English',
  AO: 'Portuguese',
  AQ: 'English',
  AR: 'Spanish',
  AS: 'English',
  AT: 'German',
  AU: 'English',
  AW: 'English',
  AZ: 'English',
  BA: 'Bosnian',
  BB: 'English',
  BD: 'English',
  BE: 'Dutch',
  BF: 'French',
  BG: 'Bulgarian',
  BH: 'Arabic',
  BI: 'French',
  BJ: 'French',
  BM: 'English',
  BN: 'English',
  BO: 'Spanish',
  BQ: 'Dutch',
  BR: 'Portuguese',
  BS: 'English',
  BT: 'English',
  BW: 'English',
  BY: 'Russian',
  BZ: 'English',
  CA: 'English',
  CC: 'English',
  CD: 'French',
  CF: 'French',
  CH: 'German',
  CI: 'English',
  CK: 'English',
  CL: 'Spanish',
  CM: 'French',
  CN: 'TraditionalChinese',
  CO: 'Spanish',
  CR: 'Spanish',
  CV: 'Portuguese',
  CX: 'English',
  CY: 'Greek',
  CZ: 'Czech',
  DE: 'German',
  DJ: 'French',
  DK: 'Danish',
  DM: 'English',
  DO: 'Spanish',
  DZ: 'Arabic',
  EC: 'Spanish',
  EE: 'Estonian',
  EG: 'Arabic',
  ER: 'Arabic',
  ES: 'Spanish',
  ET: 'English',
  FI: 'Finnish',
  FJ: 'English',
  FM: 'English',
  FO: 'Danish',
  FR: 'French',
  GA: 'French',
  GB: 'English',
  GD: 'English',
  GE: 'English',
  GF: 'French',
  GH: 'English',
  GI: 'English',
  GL: 'Danish',
  GM: 'English',
  GN: 'French',
  GP: 'French',
  GQ: 'French',
  GR: 'Greek',
  GT: 'Spanish',
  GU: 'English',
  GW: 'Portuguese',
  GY: 'English',
  HK: 'TraditionalChinese',
  HN: 'Spanish',
  HR: 'Croatian',
  HT: 'French',
  HU: 'Hungarian',
  ID: 'English',
  IE: 'English',
  IL: 'Hebrew',
  IN: 'English',
  IQ: 'Arabic',
  IS: 'Icelandic',
  IT: 'Italian',
  JM: 'English',
  JO: 'Arabic',
  JP: 'Japanese',
  KE: 'English',
  KG: 'Russian',
  KH: 'English',
  KI: 'English',
  KM: 'French',
  KN: 'English',
  KR: 'English',
  KW: 'Arabic',
  KY: 'English',
  KZ: 'Russian',
  LA: 'English',
  LB: 'Arabic',
  LC: 'English',
  LI: 'German',
  LK: 'English',
  LR: 'English',
  LS: 'English',
  LT: 'Lithuanian',
  LU: 'English',
  LV: 'Latvian',
  LY: 'Arabic',
  MA: 'Arabic',
  MC: 'French',
  MD: 'Romanian',
  ME: 'English',
  MG: 'French',
  MH: 'English',
  MK: 'Macedonian',
  ML: 'French',
  MM: 'English',
  MN: 'English',
  MO: 'TraditionalChinese',
  MP: 'English',
  MQ: 'French',
  MR: 'French',
  MS: 'English',
  MT: 'Maltese',
  MU: 'French',
  MV: 'English',
  MW: 'English',
  MX: 'Spanish',
  MY: 'English',
  MZ: 'Portuguese',
  NA: 'English',
  NC: 'French',
  NE: 'Arabic',
  NF: 'English',
  NG: 'English',
  NI: 'Spanish',
  NL: 'Dutch',
  NO: 'Norwegian',
  NP: 'English',
  NR: 'English',
  NU: 'English',
  NZ: 'English',
  OM: 'Arabic',
  PA: 'Spanish',
  PE: 'Spanish',
  PF: 'French',
  PG: 'English',
  PH: 'Arabic',
  PK: 'Arabic',
  PL: 'Polish',
  PM: 'French',
  PN: 'English',
  PR: 'English',
  PS: 'Arabic',
  PT: 'Portuguese',
  PW: 'English',
  PY: 'Spanish',
  QA: 'Arabic',
  RE: 'French',
  RO: 'Romanian',
  RS: 'Serbian',
  RW: 'English',
  SA: 'Arabic',
  SB: 'English',
  SC: 'French',
  SE: 'Swedish',
  SG: 'English',
  SH: 'English',
  SI: 'Slovenian',
  SK: 'Slovak',
  SL: 'English',
  SM: 'Italian',
  SN: 'French',
  SO: 'Arabic',
  SR: 'English',
  ST: 'Portuguese',
  SV: 'Spanish',
  SZ: 'English',
  TC: 'English',
  TD: 'French',
  TG: 'French',
  TH: 'English',
  TJ: 'English',
  TK: 'English',
  TL: 'English',
  TM: 'English',
  TN: 'Arabic',
  TO: 'English',
  TR: 'Turkish',
  TT: 'English',
  TV: 'English',
  TW: 'TraditionalChinese',
  TZ: 'English',
  UA: 'English',
  UG: 'English',
  US: 'English',
  UY: 'Spanish',
  UZ: 'English',
  VA: 'Italian',
  VC: 'English',
  VE: 'Spanish',
  VG: 'English',
  VI: 'English',
  VN: 'English',
  VU: 'English',
  WF: 'English',
  WS: 'English',
  YE: 'English',
  YT: 'English',
  ZA: 'Portuguese',
  ZM: 'English',
  ZW: 'English',
};
